<script lang="ts">
	import * as Dialog from '$lib/components/ui/dialog/index.js';

	let { open = $bindable(false) } = $props();
</script>

<Dialog.Root bind:open>
	<Dialog.Content class="h-[98vh] max-h-[670px]">
		<Dialog.Header>
			<Dialog.Description>
				<!-- Start of Meetings Embed Script -->
				<div
					class="meetings-iframe-container max-h-[630px] overflow-hidden"
					data-src="https://meetings.hubspot.com/edward-naylor/are-we-a-fit-mvmnt-tms-demo?embed=true"
				></div>
				<script
					type="text/javascript"
					src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
				></script>
				<!-- End of Meetings Embed Script -->
			</Dialog.Description>
		</Dialog.Header>
	</Dialog.Content>
</Dialog.Root>
